
/** Case-insensitive lookup in the enabled map from `GET /api/app-features`. */
export function isAppFeatureEnabled(key: string, flags: Record<string, boolean>): boolean {
  const normalized = key.trim().toLowerCase()
  if (!normalized) {
    return false
  }
  const entry = Object.entries(flags).find(([flagKey]) => flagKey.toLowerCase() === normalized)
  return entry ? entry[1] === true : false
}

/**
 * Integration gating: missing key in map = not configured in DB = allowed.
 * Present key uses its boolean value.
 */
export function isAppFeatureIntegrationEnabled(
  integrationKey: string,
  integrations: Record<string, boolean>,
): boolean {
  const normalized = integrationKey.trim().toLowerCase()
  if (!normalized) {
    return true
  }
  const entry = Object.entries(integrations).find(([key]) => key.toLowerCase() === normalized)
  if (!entry) {
    return true
  }
  return entry[1] === true
}